import React, { useMemo, useState } from "react";

import { SectionEyebrow } from "../components/CommonComponents";

export default function ProgrammeOverview({ course }) {

    return (
        <section className="py-20 sm:py-24 lg:py-28 bg-white text-[#132337]">
            <div className="container relative z-[1] mx-auto">
                <div className="grid gap-12 lg:grid-cols-[320px_1fr]">
                    <aside className="lg:sticky lg:top-24 lg:self-start">
                        <span className="text-sm font-bold uppercase tracking-[0.14em] text-[#8B1E3F]">Programme Dossier</span>
                        <h2 className="mt-4 font-['Libre_Caslon_Display',Georgia,serif] text-4xl font-normal leading-[1.1] text-[#071A2F]">
                            The essential academic picture.
                        </h2>

                        <div className="mt-8 border-t-2 border-[#071A2F]">
                            {[
                                ["School", course.school],
                                ["Level", course.level],
                                ["Duration", course.duration],
                                ["Mode", course.mode],
                                ["Campus", course.location],
                                ["Intake", course.intake],
                            ].map(([label, value]) => (
                                <div key={label} className="border-b border-[#071A2F]/15 py-4">
                                    <span className="text-sm font-bold uppercase tracking-[0.1em] text-[#65717D]">{label}</span>
                                    <p className="mt-2 text-sm font-semibold leading-6 text-[#071A2F]">{value}</p>
                                </div>
                            ))}
                        </div>
                    </aside>

                    <div>
                        <SectionEyebrow>Programme Overview</SectionEyebrow>
                        <h2 className="mt-6 max-w-4xl font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(40px,4.8vw,66px)] font-normal leading-[1.05] text-[#071A2F]">
                            Designed for strong foundations,
                            <em className="text-[#8B1E3F]"> practical confidence and progression.</em>
                        </h2>

                        <div
                            className="mt-7 max-w-4xl text-base leading-8 text-[#65717D]"
                            dangerouslySetInnerHTML={{
                                __html: course.overview,
                            }}
                        ></div>

                        <div className="mt-10 grid border-l border-t border-[#071A2F]/15 sm:grid-cols-2 lg:grid-cols-3">
                            {course.advantages?.map((item, index) => (
                                <article key={item} className="min-h-[170px] border-b border-r border-[#071A2F]/15 p-6">
                                    <span className="text-sm font-bold text-[#A77B2D]">0{index + 1}</span>
                                    <h3 className="mt-6 text-lg font-bold leading-7 text-[#071A2F]">{item}</h3>
                                </article>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
